<template>
  <div class="batchDetail">
    <!-- 详情模块 -->
    <div class="pop_goods">
      <md-popup v-model="show" position="right" @beforeHide="cancelPop">
        <div style="height:0.54rem"></div>
        <div class="pop_goods_box">
          <!-- 头部 -->
          <div class="pop_header">
            <div class="close">
              <md-icon name="wrong" size="sm" @click="cancelPop"></md-icon>
            </div>
            <div>批次详情</div>
          </div>
          <!-- 中间 -->
          <div class="pop_section">
            <template v-if="Object.keys(item).length">
              <div class="batch_title">
                <div>批次信息</div>
              </div>
              <div class="batch_base">
                <div class="base_line name">
                  <div> {{item.supplier_name}} </div>
                  <div><span style="font-size:0.18rem">￥</span>{{Number(item.goods_surcharge_amount_total)}}</div>
                </div>
                <div class="base_line">
                  <div>批次号：{{item.batch_no}} </div>
                  <div>操作员：{{item.realname}}</div>
                </div>
                <div class="base_line">
                  <div>货款总计：<span style="font-size:0.16rem">￥</span>{{Number(item.batch_amount)}} </div>
                </div>
                <div class="base_line">
                  <div>产地费用：<span style="font-size:0.16rem">￥</span>{{Number(item.batchSurcharge.produce_amount)}} </div>
                </div>
                <div class="base_line">
                  <div>市场费用：<span style="font-size:0.16rem">￥</span>{{Number(item.batchSurcharge.market_amount)}}</div>
                </div>
                <div class="base_line time">
                  <div>{{item.created_at | toTime}} </div>
                </div>
              </div>
              <div class="batch_title">
                <div>货品明细</div>
              </div>
              <div class="goods_base" v-if="item.goods && item.goods.length>0">
                <!-- <div class="title">商品明细</div> -->
                <div class="goods">
                  <div class="good_item" v-for="(good_item,good_index) in item.goods" :key="good_index">
                    <div class="name_box">
                      <div>
                        <div class="good_item_name">
                          <span class="fb">{{good_index+1}}、{{good_item.name}}</span>
                          <div class="goods_item_type">
                            <span class="goods_item_type_1" v-if="good_item.bale ==1">定装</span>
                            <span class="goods_item_type_2" v-if="good_item.bale ==2">非定装</span>
                            <span class="goods_item_type_3" v-if="good_item.bale ==3">散装</span>
                          </div>
                          <div class="goods_item_type">
                            <span class="item_type_zy" v-if="good_item.type == 1">自营</span>
                            <span class="item_type_dm" v-if="good_item.type == 2">代卖</span>
                          </div>
                        </div>
                        <!-- <span class="fb">{{good_item.amount}}元</span> -->
                      </div>
                      <div style="color:#999;margin-bottom:0.04rem">批次号：{{good_item.batch}}</div>
                    </div>
                    <div class="bale_box">
                      <table :class="'bale'+good_item.bale">
                        <tr>
                          <td v-if="good_item.bale == 1">规格</td>
                          <td v-if="good_item.bale == 1 || good_item.bale == 2">数量</td>
                          <td v-if="good_item.bale == 2 || good_item.bale == 3">重量</td>
                          <td>货款</td>
                        </tr>
                        <tr>
                          <td v-if="good_item.bale == 1">{{good_item.bale_num-0}}公斤/{{unit_list[good_item.num_unit-1].name}}</td>
                          <td v-if="good_item.bale == 1 || good_item.bale == 2">{{good_item.num-0}}{{unit_list[good_item.num_unit-1].name}}</td>
                          <td v-if="good_item.bale == 2 || good_item.bale == 3">{{good_item.weight-0}}公斤</td>
                          <td>{{Number(good_item.amount)}}元</td>
                        </tr>
                      </table>
                    </div>
                    <div class="is_sale" v-if="good_item.status == 2">
                      <img src="./../../../assets/img/work/stock/stock_saleoff.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="goods_base" v-if="Object.keys(batchSurcharge).length &&((  batchSurcharge.market &&  batchSurcharge.market.length>0)||  batchSurcharge.produce &&  batchSurcharge.produce.length>0)">
                <div class="title">其他费用</div>
                <div class="goods">
                  <div class="good_item" v-if=" batchSurcharge.market &&  batchSurcharge.market.length>0">
                    <div class="name_box">
                      <div>
                        <div class="good_item_name">
                          <span class="fb">市场费用</span>
                        </div>
                        <span class="fb">{{batchSurcharge.market_amount}}元</span>
                      </div>
                    </div>
                    <div class="bale_box">
                      <table>
                        <tr>
                          <td>费用项目</td>
                          <td>金额</td>
                        </tr>
                        <tr v-for="(fee_item,fee_index) in batchSurcharge.market" :key="fee_index">
                          <td>{{fee_item.name}}</td>
                          <td>{{fee_item.price}}元</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="good_item" v-if=" batchSurcharge.produce &&  batchSurcharge.produce.length>0">
                    <div class="name_box">
                      <div>
                        <div class="good_item_name">
                          <span class="fb">产地费用</span>
                        </div>
                        <span class="fb">{{batchSurcharge.produce_amount}}元</span>
                      </div>
                    </div>
                    <div class="bale_box">
                      <table>
                        <tr>
                          <td>费用项目</td>
                          <td>金额</td>
                        </tr>
                        <tr v-for="(fee_item,fee_index) in batchSurcharge.produce" :key="fee_index">
                          <td>{{fee_item.name}}</td>
                          <td>{{fee_item.price}}元</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </md-popup>
    </div>
  </div>
</template>
<script>
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { ownerBatch_detail }  from "@/api/work/owner";
export default {
  name: "batchDetail",
  data() {
    return {
      show:false,
      item: {},
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      batchSurcharge:{},
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 显示弹窗
    showPop(item){
      this.show = true
      ownerBatch_detail({batch_id:item.id}).then(res=>{
        if(res.code == 200 ){
          this.item = res.data
          this.batchSurcharge = res.data.batchSurcharge
        }
      })
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 完成弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData = {
        goods_id:'',
        name:"",
        type:"1",
        proposed_price: ""
      }
      this.item = {}
    },
  }
};
</script>
<style lang="less" scoped>
.batchDetail {
  // 弹出层
  .pop_goods_box {
    width: 6rem;
    height: calc(100% - 0.54rem);
    background-color: #fff;
    .pop_header {
      height: 0.68rem;
      width: 100%;
      text-align: center;
      font-size: 0.28rem;
      line-height: 0.68rem;
      position: relative;
      box-shadow: 0 0.02rem 0.04rem 0.02rem #e1e1e1;
      .close {
        position: absolute;
        left: 0.2rem;
        top: 0;
      }
    }
    .pop_section {
      width: 100%;
      height: calc(100% - 0.68rem);
      overflow: scroll;
      .batch_title{
        height: 0.58rem;
        width: 100%;
        border-bottom: 0.01rem solid #e5e5e5; 
        padding-left: 0.12rem;
        font-size: 0.24rem;
        display: flex;
        align-items: center;
        &>div{
          padding-left: 0.08rem;
          border-left: 0.04rem solid #31b158;
        }
      }
      .batch_base{
        position: relative;
        padding: 0.12rem 0.24rem;
        padding-bottom: 0.1rem;
        border-bottom: 0.1rem solid #f5f5f5;
        .base_line{
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 0.2rem;
          line-height: 0.36rem;
          &.name{
            font-weight: bold;
            font-size: 0.24rem;
            line-height: 0.5rem;
          }
          &.time{
            color: #999;
          }
        }
      }
      .goods_base{
        position: relative;
        padding:0 0.24rem 0.2rem;
        padding-bottom: 0;
        .title{
          font-size: 0.24rem;
          font-weight: bold;
        }
        .goods{
          position: relative;
          margin: 0.2rem 0;
          .good_item{
            margin-bottom: 0.1rem;
            position: relative;
            .name_box{
              font-size: 0.2rem;
              line-height: 0.30rem;
              // border: 0.02rem solid #e1e1e1;
              // border-bottom: none;
              // padding: 0 0.1rem;
              &>div{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .good_item_name{
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                }
                .fb{
                  font-weight: bold;
                  font-size: 0.24rem;
                  line-height: 0.4rem;
                }
              }
            }
            .bale_box{
              width: 100%;
              font-size: 0.24rem;
              font-weight: normal;
              table{
                width: 100%;
                border: 0.02rem solid #666;
                font-size: 0.2rem;
                td{
                  width: 50%;
                  border: 0.02rem solid #666;
                  text-align: center;
                  line-height: 0.4rem;
                }
                &.bale1,&.bale2{
                  td{
                    width: 33%;
                  }
                }
              }
            }
            .is_sale{
              position: absolute;
              right: 0.3rem;
              top: 0.1rem;
              width: 0.5rem;
              height: 0.5rem;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.batchDetail{
  .md-popup-mask{
    top: 0.54rem;
    left: 0.7rem;
  }
}

</style>